<template>

    <v-select :model="val" @input="val = $event">
        <option value="">{{ $t('labels.none') }}</option>
        <option v-for="s in sources" :key="s.id" :value="s.id">{{ s.name }}</option>
    </v-select>

</template>

<script>

export default {

    props: {
        model: {
            required: true,
        },
    },

    data() {
        return {
            val: this.model !== null && this.model !== undefined ? this.model : '',
        }
    },

    computed: {

        sources() {
            return this.project.sources;
        },

    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
